/* Copyright (c) 2017 Backpack Health LLC */

import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import DependentProfileCreation from './DependentProfileCreation.controller';

import { getMainProfileId, getProfile } from '../../redux/reduxSelectors';
import { selectors as listSelectors } from '../../../redux/ducks/lists/lists';
import NavigationActions from '../../redux/NavigationActions';
import ProfileActions from '../../redux/ProfileActions';
import RouteNames from '../../RouteNames';
import ProfilePhrases from '../../../../phraseKeys/Profile.phrase';
import { actions as systemNotificationActions, selectors as systemNotificationSelectors } from '../../../redux/ducks/systemNotification';
import { UserIntentType } from '../../../../models/UserModel';
import { userSelectors } from '../../../redux/selectors_authorizedApp';
import { actions as systemModalActions } from '../../../redux/ducks/systemModal';
import { actions as uiActions } from '../../../redux/ducks/ui';

function mapStateToProps(state, routerProps) {
  const genderCollection = listSelectors.getGenderCollection(state);

  const genderIdMap = {};
  genderCollection.forEach((g) => {
    genderIdMap[g.id] = g;
  });

  const mainProfileId = getMainProfileId(state);
  const mainProfile = getProfile(mainProfileId, state);

  const { intent } = userSelectors.getUser(state).data;
  const intendedGroupId = intent && intent.type === UserIntentType.join_group && intent.join_group && intent.join_group.group_id;

  return {
    genderIdMap,
    mainProfile,
    phraseData: ProfilePhrases.myProfile(false, ''),
    currentColorTheme: listSelectors.getCurrentColorTheme(state),
    isNotificationShown: systemNotificationSelectors.isNotificationAvailable(state),
    submitProfileChanges: (profileData) => {
      ProfileActions.api.updateProfile(profileData);
    },
    requestProfile: (profile) => {
      ProfileActions.api.getProfile(profile.data.id);
    },
    cancelCreation: () => {
      ProfileActions.setColorThemeToActiveProfile();
      NavigationActions.goBack(routerProps.history);
    },
    finishProfileCreation: (profile) => {
      ProfileActions.dispatch.setActiveProfile(profile.data);

      if (intendedGroupId) {
        NavigationActions.goTo(routerProps.history, RouteNames.joinGroup(intendedGroupId, profile.data.id))
      } else {
        NavigationActions.goBackTo(routerProps.history, RouteNames.profileInfo());
      }
    },
    loadInitialData: () => {
      ProfileActions.requestNextProfileColor((apiError, colorTheme) => {
        ProfileActions.setCurrentColorTheme(colorTheme);
      });
    },
    isResidenceStateRequired: (countryId) => {
      return listSelectors.isResidenceStateRequired(countryId, state);
    },
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showNotification: (message, color) => {
      dispatch(systemNotificationActions.showNotification(message, color));
    },
    showHintNotification: (message) => {
      dispatch(systemNotificationActions.showHintNotification(message));
    },
    dismissNotification: () => {
      dispatch(systemNotificationActions.dismissNotification());
    },
    showSystemModal: (content) => {
      dispatch(systemModalActions.show(content));
    },
    resetAppMenu: () => {
      dispatch(uiActions.closeSection());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(DependentProfileCreation));
